import { render, staticRenderFns } from "./tuihuo.vue?vue&type=template&id=36cd636e&scoped=true&"
import script from "./tuihuo.vue?vue&type=script&lang=js&"
export * from "./tuihuo.vue?vue&type=script&lang=js&"
import style0 from "./tuihuo.vue?vue&type=style&index=0&id=36cd636e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd636e",
  null
  
)

export default component.exports